export default "__VITE_ASSET__Clh$RQKd__"